<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="6" v-if="!isReadOnly">
                    <rkm-form-select
                        :options="prestadores"
                        :validations="validations.unidade"
                        label="Prestador"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        :disabled="model.unidadeDisabled ? true : false"
                        value-field="unidadeId"
                        :readonly="isReadOnly"
                    />
                </rkm-col>

                <rkm-col cols="6" v-if="isReadOnly">
                    <rkm-form-input
                        label="Prestador"
                        v-model="unidadeNome"
                        readonly
                    />
                </rkm-col>

                <rkm-col cols="6" v-if="!isReadOnly">
                    <rkm-form-select
                        label="Local de atendimento"
                        :options="infraestruturas"
                        text-field="nome"
                        v-model="model.infraestruturaId"
                        value-field="id"
                        show-default-option
                        :validations="validations.infraestruturaId"
                        :disabled="model.infraestruturaDisabled ? true : false"
                        :readonly="isReadOnly"
                    />
                </rkm-col>

                <rkm-col cols="6" v-if="isReadOnly">
                    <rkm-form-input
                        label="Local de atendimento"
                        v-model="localNome"
                        value-field="infraestruturaId"
                        readonly
                    />
                </rkm-col>
            </rkm-row>

            <rkm-area
                title="UNIDADE SOLICITANTE"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="data.form.tipos"
                            :validations="validations.cotaTipoId"
                            label="Tipo"
                            show-default-option
                            text-field="descricao"
                            v-model="model.cotaTipoId"
                            :disabled="model.cotaTipoIdDisabled ? true : false"
                            value-field="id"
                            :readonly="isReadOnly"
                        />
                    </rkm-col>

                    <rkm-col
                        cols="3"
                        v-show="model.cotaTipoId != enums.tipoCota.QUANTIDADE"
                    >
                        <rkm-form-input
                            v-if="model.cotaTipoId != enums.tipoCota.QUANTIDADE"
                            label="Valor"
                            ref="cotaValor"
                            v-model="model.cotaValor"
                            v-money="money"
                            prepend="R$"
                            :readonly="isReadOnly"
                            :disabled="!model.cotaTipoId"
                            :validations="validations.cotaValor"
                        />
                    </rkm-col>

                    <rkm-col
                        cols="3"
                        v-show="model.cotaTipoId == enums.tipoCota.QUANTIDADE"
                    >
                        <rkm-form-input
                            v-if="model.cotaTipoId == enums.tipoCota.QUANTIDADE"
                            label="Quantidade"
                            v-model="model.cotaUnidade"
                            :readonly="isReadOnly"
                            number
                            :validations="validations.cotaUnidade"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            v-model="model.periodo"
                            range
                            :min-date="minDate"
                            :max-date="maxDate"
                            :readonly="isReadOnly"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-textarea
                        label="Observação"
                        v-model="model.observacao"
                        name="observacao"
                        rows="4"
                        max-rows="4"
                        :validations="validations.observacao"
                        :readonly="isReadOnly"
                        >
                        </rkm-form-textarea>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-button
                            :label="false"
                            color="primary"
                            @click.stop="$refs.Form.validate(add)"
                            class="mt-0 float-right"
                        >
                            {{ checkHandleAlter ? 'Alterar' : 'Incluir' }}
                        </rkm-button>

                        <rkm-button
                            v-if="checkHandleAlter"
                            :label="false"
                            color="secondary"
                            @click.stop="hideAlter()"
                            class="mt-0 mr-2 float-right"
                        >
                            Voltar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-form>

        <List
            v-if="!checkHandleAlter"
            :data="data"
            :cotaSolicitante="cotaSolicitante"
            @handleAlter="handleAlter"
        />

    </div>
</template>

<script>
// Components.
import List from './List'

// Moment.
import moment from 'moment'

// Mixins.
import { object, mask, data } from '@/mixins'

//Directives
import { VMoney } from 'v-money'

// Enuns.
import tipoCota from '@/enums/exame-imagem/tipoCota'

export default {
    components: {  List },
    computed: {
        validations() {

            return {
                unidade: { required: true },
                cotaValor: {
                    max:13,
                    min_value: 0.01
                },
                cotaUnidade: {
                    required: true,
                    min_value: 1,
                    max_value: 999999,
                },
                cotaTipoId: { required: true},
                observacao: { max: 500},
            }
        },
        periodoInalterado() {

            if (!this.periodoOriginal.start || !this.periodoOriginal.end) {

                return false
            }

            return this.getFormatedDate(this.model.periodo.start, 'DD/MM/YYYY') === this.periodoOriginal.start
                && this.getFormatedDate(this.model.periodo.end, 'DD/MM/YYYY') === this.periodoOriginal.end
        },
        maxDate() {

            if (this.periodoInalterado) {

                return null
            }

            if (this.model.periodo.start) {

                return moment(this.getFormatedDate(this.model.periodo.start, 'YYYY-MM-DD')).endOf('month').format('DD-MM-YYYY')
            }

            return null
        },
        minDate() {

            if (this.periodoInalterado) {

                return null
            }

            if (this.model.periodo.end) {

                return moment(this.getFormatedDate(this.model.periodo.end, 'YYYY-MM-DD')).startOf('month').format('DD-MM-YYYY')
            }

            return null
        },
        hasIndex() {

            return this.index !== null
        },
        prestadores() {

            const unidades = []

            this.data.model.unidades.filter(u => u.prestador == true).map(unidade => {

                const unidadeInserida = unidades.find(u => u.unidadeId === unidade.unidadeId)

                if (unidadeInserida) {

                    unidadeInserida.infraestruturas.push({

                        id: unidade.infraestruturaId,
                        nome: unidade.infraestruturaNome,
                        principal: unidade.infraestruturaPrincipal,
                    })

                } else {

                    unidades.push({

                        unidadeId: unidade.unidadeId,
                        nomeFantasia: unidade.nomeFantasia,
                        infraestruturas: [
                            {
                                id: unidade.infraestruturaId,
                                nome: unidade.infraestruturaNome,
                                principal: true,
                            }
                        ]
                    })
                }
            })

            this.getUnidade(unidades)

            return unidades
        },
        infraestruturas() {

            if (this.model.unidadeId) {

                let infraestruturaPrincipal = this.prestadoresParametrizados.find(u => u.unidadeId === this.model.unidadeId)
                    .infraestruturas

                    if (!this.model.unidadeDisabled) {

                        this.getPrincipal(infraestruturaPrincipal)
                    }

                return infraestruturaPrincipal
            }

            return []
        },
    },
    created() {

        this.load()
    },
    data: () => ({
        model: {
            id: null,
            unidadeId: null,
            unidadeDisabled: false,
            infraestruturaDisabled: false,
            cotaTipoIdDisabled: false,
            cotaTipoId: null,
            cotaValor: '',
            cotaUnidade: null,
            observacao: null,
            prestador: null,
            infraestruturaId: null,
            infraestruturaNome: '',
            periodo: {
                start: null,
                end: null
            },
        },
        periodoOriginal: {
            start: null,
            end: null,
        },
        checkHandleAlter: false,
        cotaSolicitante: [],
        unidadeNome: '',
        localNome: null,
        isReadOnly: false,
        enums: {
            tipoCota
        },
        newIndex: null,
        indexList: null,
        money: {
          decimal: ',',
          thousands: '.',
          suffix: '',
          precision: 2,
          masked: false
        },
        cotasSalvas: [],
    }),
    methods: {
        load() {

            this.model.prestador = this.data.model.unidades.filter(field => field.prestador == true)
                .map(permissao => {

                    return {
                        unidadeId: permissao.unidadeId,
                        nomeFantasia: permissao.nomeFantasia,
                    }
                })

             if (this.hasIndex) {

                const objId = this.data.model.cotas.findIndex((obj => obj.unidadeId == this.item.unidadeId
                    && obj.infraestruturaId == this.item.infraestruturaId));

                this.newIndex = objId

                const data = this.data.model.cotas[objId]

                this.model.unidadeId = data.unidadeId
                this.model.infraestruturaId = data.infraestruturaId
                this.model.unidadeDisabled = true
                this.model.infraestruturaDisabled = true
                this.cotaSolicitante = data.cotaSolicitante

                if (this.model.prestador.find(m => m.unidadeId == data.unidadeId) == undefined){
                    this.isReadOnly = true
                }

                this.unidadeNome = this.data.model.cotas.find(s => s.unidadeId == data.unidadeId).nomeFantasia

                this.localNome = this.data.model.cotas.find(l => l.infraestruturaId == data.infraestruturaId)
                    .infraestruturaNome
                this.$emit('novaCota', false)
            } else {
                this.$emit('novaCota', true)
            }
        },
        getUnidade(unidades) {

            this.prestadoresParametrizados = unidades
        },
        getPrincipal(infraestruturaPrincipal) {

            if (infraestruturaPrincipal.find(u => u.principal === true)) {

                this.model.infraestruturaId = infraestruturaPrincipal.find(u => u.principal === true).id

            } else {

                this.model.infraestruturaId = null
            }
        },
        add(){

            this.validate()
                .then(valid => {

                    if (!valid) return

                    const cotas = this.clone(this.model)

                    if(this.handleAlter) {
                        this.model.id = null;
                    }

                    cotas.periodo.start = this.getFormatedDate(this.model.periodo.start, 'DD/MM/YYYY')
                    cotas.periodo.end = this.getFormatedDate(this.model.periodo.end, 'DD/MM/YYYY')
                    cotas.cotaValor = cotas.cotaValor.replace('R$ ', '')

                    if (this.model.cotaTipoId == this.enums.tipoCota.VALOR) {
                        cotas.cotaValor = cotas.cotaValor.replace('R$ ', '')
                        cotas.cotaTipoNome = 'Valor'
                        cotas.cota = cotas.cotaValor
                        cotas.saldo = cotas.cotaValor
                        cotas.cotaUnidade = ''
                    } else {
                        cotas.cotaTipoNome = 'Quantidade'
                        cotas.cota = cotas.cotaUnidade
                        cotas.saldo = cotas.cotaUnidade
                        cotas.cotaValor = "0,00"
                    }

                    if (this.indexList !== null) {
                        this.$set(this.cotaSolicitante, this.indexList, this.clone(cotas))
                    } else {
                        this.cotaSolicitante.push(cotas)
                    }

                    if (this.newIndex === null) {
                        const unidade = this.prestadores.find(u => u.unidadeId === this.model.unidadeId)
                        const infraestrutura = this.infraestruturas.find(u => u.id === this.model.infraestruturaId)

                        const param = {
                            id: this.model.id,
                            unidadeId: unidade.unidadeId,
                            nomeFantasia: unidade.nomeFantasia,
                            infraestruturaId: infraestrutura.id,
                            infraestruturaNome: infraestrutura.nome,
                            cotaSolicitante: this.cotaSolicitante,
                        }

                        this.cotasSalvas.push(this.clone(param));
                        this.newIndex = this.cotasSalvas.findIndex((user) => user.unidadeId === unidade.id && user.infraestruturaId == infraestrutura.id)
                    } else {
                        this.checkHandleAlter = false
                    }

                    if(this.cotasSalvas.length > 0 && this.cotasSalvas[this.newIndex]){
                        this.cotasSalvas[this.newIndex].cotaSolicitante = this.cotaSolicitante;
                    }

                    this.indexList = null

                    this.resetForm()
                })
        },
        async validate() {

            if (!this.model.unidadeDisabled && this.data.model.cotas.find((unidade, i) =>
                i !== this.newIndex && unidade.unidadeId == this.model.unidadeId
                && unidade.infraestruturaId == this.model.infraestruturaId)) {

                this.showValidationNotification('Unidade e local de atendimento já parametrizados.')

                return false
            }

            if (this.model.periodo.start === null || this.model.periodo.end === null) {

                this.showValidationNotification('Obrigatório informar o início e o fim do período.')

                return false
            }
            const hasSetor = this.cotaSolicitante.find((cc) => {
                
                const idDiferente = !cc.id || !this.model.id || cc.id !== this.model.id;

                return idDiferente && (
                        moment(this.getFormatedDate(this.model.periodo.start, 'YYYY-MM-DD'))
                            .isBetween(
                                cc.periodo.start.split("/").reverse().join("-"),
                                cc.periodo.end.split("/").reverse().join("-"),
                                null,
                                '[]'
                            )
                        || 
                        moment(this.getFormatedDate(this.model.periodo.end, 'YYYY-MM-DD'))
                            .isBetween(
                                cc.periodo.start.split("/").reverse().join("-"),
                                cc.periodo.end.split("/").reverse().join("-"),
                                null,
                                '[]'
                            )
                        ||
                        (
                            moment(this.getFormatedDate(this.model.periodo.start, 'YYYY-MM-DD'))
                                .isBefore(cc.periodo.start.split("/").reverse().join("-"))
                            &&
                            moment(this.getFormatedDate(this.model.periodo.end, 'YYYY-MM-DD'))
                                .isAfter(cc.periodo.end.split("/").reverse().join("-"))
                        )
                );
            })

            if (hasSetor) {

              this.showValidationNotification(`Já existe um registro para esta unidade entre o período selecionado`)

               return false
            }

            return true
        },
        handleAlter(index, item) {

            this.resetForm()

            this.indexList = index
            this.model.id = item.id
            this.model.cotaUnidade = item.cotaUnidade
            this.model.observacao = item.observacao
            this.model.cotaValor = item.cotaValor
            this.$refs.cotaValor.$el.getElementsByTagName('input')[0].value = item.cotaValor;

            this.model.periodo.start = moment(item.periodo.start, 'DD/MM/YYYY').toDate()
            this.model.periodo.end = moment(item.periodo.end, 'DD/MM/YYYY').toDate()

            this.periodoOriginal = {
                start: item.periodo.start,
                end: item.periodo.end,
            }

            this.model.cotaTipoId = item.cotaTipoId
            this.checkHandleAlter = true
        },
        hideAlter() {

            this.checkHandleAlter = false

            this.resetForm()
        },
        resetForm() {

            this.model.observacao = null
            this.model.periodo.start = null
            this.model.periodo.end = null

            this.periodoOriginal = {
                start: null,
                end: null,
            }
            this.model.cotaTipoId = null
            this.model.cotaUnidade = ''
            this.model.cotaValor = 0

            if(this.$refs.cotaValor){
                this.$refs.cotaValor.$el.getElementsByTagName('input')[0].value = 0;
            }

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },

        save() {
            this.data.model.cotas.push(...this.clone(this.cotasSalvas));
        }
    },
    directives: { money: VMoney },
    mixins: [object, mask, data],
    props: {
        data: { type: Object, required: true },
        index: { type: Number, default: null },
        item: { type: Object, default: null },
    },
}
</script>